import { useLanguage } from '../../hooks/useLanguage';

/**
 * LanguageToggle 组件的 Props
 */
interface LanguageToggleProps {
  className?: string;
}

/**
 * 语言切换组件
 * 
 * 功能：
 * - 显示当前语言标识（中/EN）
 * - 点击切换语言（中文 ⇄ 英文）
 * - 自动保存语言偏好到 localStorage
 * 
 * @param props - 组件属性
 * @returns 语言切换按钮
 */
export function LanguageToggle({ className = '' }: LanguageToggleProps) {
  const { language, setLanguage } = useLanguage();

  /**
   * 切换语言
   */
  const toggleLanguage = () => {
    const newLanguage = language === 'zh' ? 'en' : 'zh';
    setLanguage(newLanguage);
  };

  /**
   * 获取当前语言的显示文本
   */
  const displayText = language === 'zh' ? '中' : 'EN';

  return (
    <button
      onClick={toggleLanguage}
      className={`
        px-3 py-1.5 
        text-sm font-medium
        text-gray-700 hover:text-primary
        bg-white hover:bg-gray-50
        border border-gray-300 hover:border-primary
        rounded-md
        transition-all duration-200
        focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2
        ${className}
      `.trim()}
      aria-label={`切换语言 / Switch Language (当前: ${displayText})`}
      title={language === 'zh' ? '切换到英文' : 'Switch to Chinese'}
    >
      {displayText}
    </button>
  );
}
